const insideClientTranslations = [
    'clientDashboard',
    'ai_integration',
    'common',
    'dashboardChecklist',
    'emptyProject',
    'expertDashboard',
    'faq',
    'grants',
    'program_consulting',
    'program_preview_card',
    'programs',
    'project',
    'project-single',
    'propulsion',
    'provider-profile',
    'recent_roadmap_program',
    'resource',
    'rfp',
    'projectStatus',
    'programs_labels',
    'article',
    'funding_explorer',
    'singleCompanyPage',
    'rfpClientModal',
    'rfpClientStatuses',
    'rfpClientRfpActionCard',
    'rfpClientRfpTab',
    'rfpClientRfpHeader',
    'rfpClientMatchesList',
    'rfpClientNoRfp',
    'rfpClientTableColumnLabels',
    'rfpClientSubmitRfpForm',
    'rfpClientOverview',
    'grantNotificationJourneys',
    'totals',
    'notification',
    'onboardingClient',
    'legalStructure',
    'program_candidates_data',
    'companyInfoModal',
    'customClientSendModal',
    'grantsViewedHistory',
    'gin_steps_client',
    'grantProfiles',
    'providerListing',
];
const insidePartnerTranslations = [
    'rfp',
    'common',
    'modal',
    'payment',
    'profile',
    'navigation',
    'notification',
    'provider-profile',
    'expertise',
    'onboarding',
    'referral',
    'faq',
    'reviews',
];
const insideAdminTranslations = [
    'companyForm',
    'createApplication',
    'project',
    'companyAdminPage',
    'singleCompanyPage',
    'company',
    'formSubmission',
    'application_single',
    'grant_single',
    'programs_admin',
    'createCompany',
    'rfp',
    'provider_details',
    'form',
    'gamePlanPdf',
    'fundingTrajectory',
    'create_program',
    'provider_form',
    'providerStatus',
    'provider_page',
    'createRfp',
    'rfps_admin',
    'headerBar',
    'searchBarAdmin',
    'reviewsAdmin',
    'application_list',
    'admin_settings',
    'gin_history',
    'files_gin',
    'gin_section',
    'gin_steps',
    'assets',
    'assetsUpload',
    'gin_program',
    'mandated_agents',
    'available_rfps',
    'referred_rfps',
    'refused_rfps',
    'reviews',
    'programs_labels',
    'program_candidates_data',
    'grant_form',
    'grantNotificationJourneys',
    'projects_page',
    'adminDashboard',
    'scrape',
    'notification',
    'googleDrive',
    'grantScrapes',
    'auth0',
    'grantSuggestions',
];
export const CoreTranslations = [
    'assetsUpload',
    'assets',
    'profile',
    'button',
    'company',
    'review_card',
    'grant_card',
    'gamePlanPdf',
    'fundingTrajectory',
    'actions',
    'grant_single',
    'grant_single_labels',
    'files_gin',
    'assets_upload',
    'gin_section',
    'provider-profile',
    'navigation',
    'rfp',
    'language',
    'portfolio',
    'reviews',
    'adminCard',
    'common',
    'footer',
    'commonComponents',
    'errorsPage',
    'admin_settings',
    'appsNames',
    'funding_explorer',
    'grant_card_status',
    'projectStatus',
    'programs',
    'companyForm',
    'form_viewer',
    'province',
    'portfolioAssetsModal',
    'profile_portfolio',
    'grants',
    'grant_eligibility_criteria',
    'programs_label',
    'application_single',
    'application',
    'project_single',
    'form',
    'profile_sections',
    'profile_header',
    'profile_about',
    'profile_video',
    'profile_contact',
    'profile_banners',
    'profile_expertise',
    'profile_overview',
    'profile_reviews',
    'profile_team',
    'profile_projects',
    'review_contact',
    'adminCard',
    'projectStatusFlow',
    'grant_notification',
    'singleCompanyPage',
    'annualRevenue',
    'companySize',
    'grantsFundingExplorer',
    'rfpClientRfpPage',
    'rfpClient',
    'rfpClientRfpDetails',
    'rfpClientMatchRejectModal',
    'rfpClientFilters',
    'premium_feature',
    'notification',
    'checkoutFlow',
    'plansDurations',
    'grant_notification_fields',
    'favorites',
    'gin_steps',
    'gin_steps_client',
    'fundingIntelligence',
    'scoreCard',
    'grantInsights',
];
export const PartnerTranslations = Array.from(new Set([...insidePartnerTranslations, ...CoreTranslations]));
export const AdminTranslations = Array.from(new Set([...insideAdminTranslations, ...CoreTranslations]));
export const ClientTranslations = Array.from(new Set([...insideClientTranslations, ...CoreTranslations]));
